import React from 'react'

import { Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  string,
  func,
  node,
} from 'prop-types'

const ICON_SIZE = { width: '20', height: '20' }

// One dropdown row: leading glyph + label, plus optional trailing content (e.g. a
// badge). Matches the "For Designers" dropdown row markup so the two dropdowns share
// the .unified-nav__dropdown design system. The icon box is always rendered so rows
// stay aligned even when a row has no glyph (e.g. the admin link).
function MenuItem({
  title,
  url,
  svgComponent = null,
  dataName,
  dataMethod = 'get',
  onClick = null,
  children = null,
}) {
  return (
    <li className="unified-nav__dropdown-item">
      <a
        href={url}
        className="unified-nav__dropdown-link cgt-body-base-semibold js-track-link-click"
        data-keyword={dataName}
        data-track-text={title}
        data-track-label="Profile"
        data-method={dataMethod}
        onClick={onClick}
      >
        <span className="unified-nav__dropdown-item-icon">
          {svgComponent && (
            <Icon notSpaced color="dark" size={ICON_SIZE} svgComponent={svgComponent} />
          )}
        </span>
        <span className="unified-nav__dropdown-item-label">{title}</span>

        {children && (
          <span className="unified-nav__dropdown-item-trail">{children}</span>
        )}
      </a>
    </li>
  )
}

MenuItem.propTypes = {
  title: string.isRequired,
  url: string.isRequired,
  svgComponent: func,
  dataName: string.isRequired,
  dataMethod: string,
  onClick: func,
  children: node,
}

export default MenuItem
